import script from "./CheckoutSuccessPage.vue?vue&type=script&setup=true&lang=js"
export * from "./CheckoutSuccessPage.vue?vue&type=script&setup=true&lang=js"

import "./CheckoutSuccessPage.vue?vue&type=style&index=0&id=2fe57a42&scoped=true&lang=css"

import exportComponent from "E:\\TestProject Temurako\\e-commerce-app-master\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2fe57a42"]])

export default __exports__